import { getCoordinatorApi } from "@/lib/api";
import type { OrgProjectScope } from "@/lib/resource-context";

export const deleteProjectInvitation = async ({
  invitationId,
  scope,
}: {
  invitationId: string;
  scope: OrgProjectScope;
}): Promise<void> => {
  const client = getCoordinatorApi(scope);
  await client.delete(`/invitations/${invitationId}`);
};
